
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"18","viewBox":"0 0 91.5 59"}},[_c('path',{attrs:{"fill":"#AAA","d":"M89.1 26.8S65.1 1.5 45.9 1.5 2.6 26.8 2.6 26.8c-2.4 2.3-2.4 3 0 5.3 0 0 24 25.3 43.2 25.3S89 32.1 89 32.1c2.4-2.3 2.4-3 .1-5.3z"}}),_c('circle',{attrs:{"fill":"#FFF","cx":"45.8","cy":"29.4","r":"14.7"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      